import { DateService } from "../../../service/DateService";
import { IBoFormVersion } from "../../../model/form/BoFormVersion";
import { FormalCheckStatus } from "../../../common/Constants";

export interface TBoFormVersionPresentationModel {
  id: number;
  sendDate?: string;
  status: string;
  version: number;
  regularCheckStatus?: string;
  forPublication: boolean;
  publicationDate?: string;
  lngLanguageCode: string;
  numberItemElectronicRegistry?: string;
  subNumberItemElectronicRegistry?: string;
  sender?: string;
  formalCheckStatus?: boolean;
  digitallySigned?: boolean;
  signatureDateString?: string;
}

const BoFormVersionPresentationModel = (
  data: IBoFormVersion
): TBoFormVersionPresentationModel => {
  const sendDate = data.sendDate
    ? DateService().formatDate(data.sendDate)
    : undefined;
  const publicationDate = data.publicationDate
    ? DateService().formatDate(data.publicationDate)
    : undefined;
  const formalCheckStatus = data.formalCheckStatus
    ? data.formalCheckStatus === FormalCheckStatus.ACCEPT
    : undefined;
  const signatureDateString = data.signatureDate
    ? DateService().formatDate(data.signatureDate)
    : undefined;
  return {
    id: data.id,
    sendDate,
    status: data.status,
    version: data.version,
    regularCheckStatus: data.regularCheckStatus,
    forPublication: data.forPublication,
    publicationDate,
    lngLanguageCode: data.lngLanguageCode,
    numberItemElectronicRegistry: data.numberItemElectronicRegistry,
    subNumberItemElectronicRegistry: data.subNumberItemElectronicRegistry,
    sender: data.sender,
    formalCheckStatus,
    digitallySigned: data.digitallySigned,
    signatureDateString
  };
};

export default BoFormVersionPresentationModel;
